<template>
    <Form
        :vm-monitoring-setting="vmMonitoringSetting"
        :errors="errors"
        @form-submitted="submitData"
    />
</template>

<script setup>
import Form from '~@/Components/Settings/VmMonitoringSettings/Form'
import { route } from '~@/Composables/route'

defineProps({
    vmMonitoringSetting: {
        type: Object,
        default: () => ({})
    },
    errors: {
        type: Object,
        default: () => ({})
    }
})

const submitData = (form) => {
    form.post(route('settings.vm-monitoring-settings.store'))
}
</script>
